var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2582 0H4.74182C2.12298 0 0 2.13281 0 4.76377V16.2362C0 18.8672 2.12298 21 4.74182 21H16.2582C18.877 21 21 18.8672 21 16.2362V4.76377C21 2.13281 18.877 0 16.2582 0Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2784 6.11285H14.7599L11.5234 9.82959L15.3308 14.8867H12.3494L10.0144 11.8198L7.34222 14.8867H5.85991L9.32163 10.9116L5.66919 6.11285H8.72608L10.8367 8.91647L13.2784 6.11285ZM12.7583 13.9959H13.5795L8.28024 6.95715H7.39923L12.7583 13.9959Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.7e0cadb25b621b22e0b0fe83236b33f1.svg";
export { ForwardRef as ReactComponent };